var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOccupiedFreeUnisexUnisex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 20,
    viewBox: "0 0 64 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34_309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 19,
    rx: 9.5,
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34_309)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 19,
    rx: 9.5,
    stroke: "#AEB0BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.1301,
    y: -14.412,
    width: 55.0175,
    height: 48,
    transform: "rotate(17.2535 39.1301 -14.412)",
    fill: "#AEB0BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupiedFreeUnisexUnisex);
export default __webpack_public_path__ + "static/media/occupied-free-unisex-unisex.03a5ae7da93df675ac13cfae45c7d7ce.svg";
export { ForwardRef as ReactComponent };